import { render, staticRenderFns } from "./SliderRGBCanvas.vue?vue&type=template&id=f1c01f9c&"
import script from "./SliderRGBCanvas.vue?vue&type=script&lang=ts&"
export * from "./SliderRGBCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./SliderRGBCanvas.vue?vue&type=style&index=0&id=f1c01f9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports